import { API } from '../utils/api'
import { Booking } from '../utils/booking'
import { BookingData, Journeys } from '../types'
import { getTimeString, log } from '../utils/helpers'

export class MetricsService extends API {
	#venueId: number

	constructor(root: string, venueId: number) {
		super(root)
		this.#venueId = venueId
	}
	/* --------------------------------------------------------
     | METRICS UTILS
     --------------------------------------------------------- */
	isProd(): boolean {
		return this.getRoot() === process.env.REACT_APP_METRICS_API_PROD
	}
	getVenueId(): number {
		return this.#venueId
	}
	/* --------------------------------------------------------
     | METRICS
     --------------------------------------------------------- */
	async #metricsWrapper(event: string, term: string, value: string | number, journey: Journeys) {
		log(`metrics -> ${event}`, term, value)
		if (!this.isProd()) return
		await this.get(`log?${this.serialize({ event, term, value, journey })}`)
	}
	
	async loadEvent(bookingData: BookingData): Promise<void> {
		await this.#metricsWrapper('checkout', 'locator', bookingData.locator, bookingData.journey)
	}

	async dateSelectionEvent(bookingData: BookingData): Promise<void> {
		await this.#metricsWrapper('checkout', 'date-select', bookingData.date.split('T')[0], bookingData.journey)
	}

	async shiftSelectionEvent(bookingData: BookingData): Promise<void> {
		const time = getTimeString(bookingData.date)
		await this.#metricsWrapper('checkout', 'shift-select', time, bookingData.journey)
	}

	async productSelectionEvent(bookingData: BookingData): Promise<void> {
		const summary = new Booking(bookingData).getBookingSummary()
		await this.#metricsWrapper('checkout', 'products-select', summary.total, bookingData.journey)
	}
	
	async ticketsSelectionEvent(bookingData: BookingData): Promise<void> {
		const time = getTimeString(bookingData.date)
		await this.#metricsWrapper('checkout', 'tickets-select', time, bookingData.journey)
	}

	async paymentMethodSelectEvent(bookingData: BookingData): Promise<void> {
		await this.#metricsWrapper('checkout', 'payment-method', 'credit-card', bookingData.journey)
	}

	async paymentEvent(bookingData: BookingData): Promise<void> {
		await this.#metricsWrapper('checkout', 'payment-success', bookingData.locator, bookingData.journey)
	}

	async paymentErrorEvent(error: string, bookingData: BookingData): Promise<void> {
		await this.#metricsWrapper('checkout', 'payment-error', error, bookingData.journey)
	}



	serialize = (obj: any) => {
		let str = []
		for (let p in obj)
			if (obj.hasOwnProperty(p)) {
				str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
			}
		str.push('venueId=' + this.#venueId)
		return str.join('&')
	}
}
